export default "/assets/trash-can-white-outline.svg";